// NO Firebase SDK imports at all — the SDK always opens WebSocket channels
// which get blocked by ad blockers (uBlock, Brave, etc.)
// Everything goes through the Firestore REST API via plain fetch().

export const PROJECT_ID = 'portfolio-e79b8-5854c';
export const STORAGE_BUCKET = 'portfolio-e79b8-5854c.appspot.com'; // ← add this
export const API_KEY    = 'AIzaSyDLsmnqt6wth0b3hZYrnllXnJIcjUaK8Uc';
export const REST_BASE  = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents`;